module.exports = __webpack_public_path__ + "img/3icon@2x.2a61cf2b.png";